import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Performance = () => {
  return (
    <EmptyPage
      title="Performance Analytics"
      description="Track and analyze the performance of your deals, projects, and valuations with detailed metrics, ROI calculations, and comparative analysis."
      icon="📈"
    />
  );
};

export default Performance;
